<script setup>
import { ref, onMounted } from 'vue'
import { get_packages, get_characteristics } from '@/services/option'
import packageCard from './component/packageCard.vue';

onMounted(async()=>{
  let packagesResponse = await get_packages()
  const items = await parsePackage(packagesResponse.result)
  isLoading.value = false
  if (packagesResponse){
    items.forEach(item => {
      if (Object.keys(item.characters).length !== 0){
        packages.value[item.package_type].characters = item.characters
      }

      if ("options" in item && Object.keys(item.options).length !== 0) {
        packages.value[item.package_type].options = item.options;
        packages.value[item.package_type]['id'] = item.id;
      }
    });
  }
})

async function parsePackage(packages){
  const updatedPackages = await Promise.all(packages.map(async (item) => {
    const response = await get_characteristics(item.id)
    let parsedChar = parserCharacteristic(response.result)
    item['characters'] = parsedChar
    return item
  }))
  return updatedPackages
}

function parserCharacteristic(responseData){
  const parsedData = responseData.data.map(item => {
    const name = item.attributes.name;
    const id = item.id;
    const traits = [];
  
    // Find the related option_meta data for the current item
    const optionMetaData = item.relationships.traits.data.map(trait => {
      const traitDetails = responseData.included.find(includedItem => includedItem.id === trait.id);
  
      if (traitDetails) {
        let temp = {}
        temp['name'] = traitDetails.attributes.name
        temp['id'] = traitDetails.id
        traits.push(temp)
      }
  
      return traitDetails;
    });
  
    return { id, name, traits };
  });
  return parsedData
}

const isLoading = ref(true)
const packages = ref({
  package_a:{
    options: {
      trial_id: {id: '', value: ''},
      min: {id: '', value: ''},
      max: {id: '', value: ''},
      name: {id: '', value: ''},
      description: {id: '', value: ''},
      sample_text: {id: '', value: ''}
    },
    characters: [
      {
        id: 'talent',
        name: 'Talent',
        traits: [],
        tempTrait: ''
      },
      {
        id: 'iq',
        name: 'IQ',
        traits: [],
        tempTrait: ''
      },
      {
        id: 'eq',
        name: 'EQ',
        traits: [],
        tempTrait: ''
      },
      {
        id: 'personality',
        name: 'Personality',
        traits: [],
        tempTrait: ''
      },
      {
        name: 'Overall Wellness',
        traits: [],
        tempTrait: ''
      },
    ]
  },
  package_b:{
    options: {
      trial_id: {id: '', value: ''},
      min: {id: '', value: ''},
      max: {id: '', value: ''},
      name: {id: '', value: ''},
      description: {id: '', value: ''},
      sample_text: {id: '', value: ''}
    },
    characters: [{traits: []}]
  },
  package_c:{
    options: {
      trial_id: {id: '', value: ''},
      min: {id: '', value: ''},
      max: {id: '', value: ''},
      name: {id: '', value: ''},
      description: {id: '', value: ''},
      sample_text: {id: '', value: ''}
    },
    characters: [{traits: []}]
  }
})
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Profiling Settings"/>
    
    <div v-auto-animate v-if="!isLoading">
      <div class="row">
        <div class="card">
          <div class="card-header">
            <h5>Profiles</h5>
          </div>
          <div class="card-body">
            <packageCard :data='packages.package_a' :package_id="packages.package_a.id" />
            <packageCard :data='packages.package_b' :package_id="packages.package_b.id" />
            <packageCard :data='packages.package_c' :package_id="packages.package_c.id" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadingCard/>
    </div>
  </div>
</template>